import { createSlice } from "@reduxjs/toolkit";
import { ClientPriceException } from "../../types/clients-module-types";

type ClientPriceExceptionsState = {
  isLoadingPriceExceptions: boolean;
  isLoadedPriceExceptions: boolean;
  priceExceptionsInfo: ClientPriceException[] | null;
};

const initialState: ClientPriceExceptionsState = {
  isLoadingPriceExceptions: true,
  isLoadedPriceExceptions: false,
  priceExceptionsInfo: null,
};

export const clientPriceExcetionsSlice = createSlice({
  name: "clientPriceExceptions",
  initialState,
  reducers: {
    loadPriceExceptionTab: (state, action) => {
      state.priceExceptionsInfo = action.payload.data;
      state.isLoadingPriceExceptions = false;
      state.isLoadedPriceExceptions = true;
    },
    setIsLoadingPriceExceptions: (state, action) => {
      state.isLoadingPriceExceptions = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const { loadPriceExceptionTab, setIsLoadingPriceExceptions } =
  clientPriceExcetionsSlice.actions;

export const IsLoadingPriceExceptions = (state: any) => {
  return state.clientPriceExceptions.isLoadingPriceExceptions;
};

export const IsLoadedPriceExceptions = (state: any) => {
  return state.clientPriceExceptions.isLoadedPriceExceptions;
};

export const SelectClientPriceExceptions = (state: any) => {
  return state.clientPriceExceptions.priceExceptionsInfo;
};

export default clientPriceExcetionsSlice.reducer;
